import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { bool, shape } = SchemaPropTypes;

const Password = shape({
  meta: shape({
    success: bool,
  }),
});

export default Password;



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/shared/schemas/Password.js